import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1A1A1A",
      "fill-rule": "evenodd",
      d: "M7 16h10a5 5 0 0 1 5 5 1 1 0 0 1-1.993.117l-.012-.293a3 3 0 0 0-2.819-2.819L17 18H7a3 3 0 0 0-3 3 1 1 0 0 1-2 0 5 5 0 0 1 4.783-4.995zh10zm5-14a6 6 0 1 1 0 12 6 6 0 0 1 0-12m0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
    }, null, -1)
  ]))]))
}
export default { render: render }